/** @jsx jsx */
import { jsx } from '@emotion/react';
import tw from 'twin.macro';

const Error = tw.p`
  text-xs text-red-600 mt-1
`;

export default Error;
